import styled from '@emotion/styled'

export const Break = styled.div`
  border-top: 1px dashed var(--White90);
`
